import React, { useState } from 'react';
import styles from './Image.module.css';
import Spinner from "../Spinner/Spinner"; // Import the CSS module

function Image({ src, alt, className}) {
    const [loading, setLoading] = useState(true);

    const handleImageLoad = () => {
        setLoading(false);
    };

    return (
        <div className={`${styles.imageContainer} ${className? className : ''}`}>
            {loading && (
                <Spinner className={styles.spinner}/>
            )}

            <img
                src={src}
                alt={alt}
                className={styles.styledImage}
                onLoad={handleImageLoad}
            />

        </div>
    );
}

export default Image;